export const COUNTRIES_ACTIONS = {
    GET: 'GET_COUNTRIES',
    FIND: 'FIND_COUNTRIES',
    CHANGE_STATUS: 'CHANGE_STATUS_COUNTRIES',
    SUCCESS: 'SUCCESS_COUNTRIES',
    ERROR: 'ERROR_COUNTRIES',
    CLEAN: 'CLEAN_COUNTRIES',

    SUGGESTION: 'SUGGESTION_COUNTRIES',
    SUGGESTION_CLEAN: 'SUGGESTION_CLEAN_COUNTRIES',
}